// -- == //
import React, { useEffect, useRef, useState } from 'react';

import * as S from './styles';
import * as T from 'common/types';

/* Inline, so each follows `currentColor` through its own hover and disabled
   states instead of being repainted by a `beforeInjection` callback. */
const ChevronIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    width="15"
    height="15"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

interface Iprops {
  label?: string;
  disabled?: boolean | undefined;
  onChange?: (list: T.Form.ListDropdownItem[], item?: T.Form.ListDropdownItem) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  style?: object;
  inputStyle?: object;
  id?: string;
  error?: boolean;
  success?: boolean;
  message?: string;
  list: any[];
  iconColor?: string;
  defaultValues?: any[];
  className?: string;
  ref?: any;
  placeholder?: string;
  labelStyle?: object;
  mini?: boolean;
  oneItem?: boolean;
  showResults?: boolean;
  onChangeValue: (val?: string) => void;
  loading: boolean;
}

const NotificationUserMultiDropdown: React.FC<Iprops> = ({
  label,
  id,
  disabled,
  style,
  error,
  success,
  message,
  list,
  onChange,
  defaultValues = [],
  inputStyle,
  onFocus,
  onBlur,
  className,
  ref,
  placeholder,
  labelStyle,
  mini,
  onChangeValue,
  loading
}) => {
  // const [values, setValues] = useState<any[]>([...defaultValues]);

  const [show, setShow] = useState<boolean>(false);
  const wrapperRef: React.MutableRefObject<any> = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
      if (onBlur) {
        onBlur();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onBlur]);

  const renderActiveItem = (selectDay: any) => {
    const checkDay = (day: any) => {
      if (day.id === selectDay.id) return true;
      else return false;
    };

    if (defaultValues.find(checkDay)) return true;
    else return false;
  };

  // useEffect(() =>{
  //   if(hasbeenReset) {
  //     reset(setValue);
  //   }
  //   console.log('hey')
  // }, [hasbeenReset]);

  const handleChange = (item: any) => {
    if (renderActiveItem(item)) {
      // setValues((newValues) =>
      //   newValues.filter((e: T.Form.ListDropdownItem) => e.id !== item.id)
      // );
      if (onChange) onChange(defaultValues.filter((e: T.Form.ListDropdownItem) => e.id !== item.id));

      return;
    }
    if (onBlur) {
      onBlur();
    }
    // setValues([...values, item]);
    if (onChange) onChange([...defaultValues, item], item);
  };

  const handleShow = () => {
    if (!show) setShow(true);
    else setShow(false);
    if (onFocus) {
      onFocus();
    }
  };
  return (
    <S.inputContainer
      style={style}
      className={error ? `error ${className}` : success ? `success ${className}` : `${className}`}
      ref={wrapperRef}
    >
      {label && (
        <S.label className="input-label" htmlFor={id} style={labelStyle} onClick={handleShow}>
          {label}
        </S.label>
      )}
      <S.InputBox>
        <S.input
          id={id}
          disabled={disabled}
          placeholder={placeholder}
          onClick={handleShow}
          // value={
          //   values.length ? values.map((item) => item.displayName + ", ") : ""
          // }
          // readOnly
          onChange={(e) => onChangeValue(e.target.value)}
          style={inputStyle}
          className={`${mini ? 'mini' : ''} ${show ? 'dropdown-show' : ''}`}
          ref={ref}
        />
        <S.icon onClick={handleShow} className={mini ? 'mini' : ''}>
          <ChevronIcon />
        </S.icon>
        {/* {values?.icon ? (
        <S.iconSelect>
          <S.arrowImg src={values?.icon} />
        </S.iconSelect>
      ) : (
        <></>
      )} */}
        <S.dropDownItems className={`drop-down__items ${show ? 'show' : ''}`}>
          {!loading ? (
            list?.length ? (
              list.map((item: any, index: number) => {
                return (
                  <S.dropDownItem key={index}>
                    <S.CheckText>{item.displayName}</S.CheckText>
                    <S.AddButton
                      type="button"
                      onClick={() => handleChange(item)}
                      className={renderActiveItem(item) ? 'active' : ''}
                      disabled={renderActiveItem(item)}
                      title={renderActiveItem(item) ? 'Already selected' : `Add ${item.displayName}`}
                      aria-label={renderActiveItem(item) ? 'Already selected' : `Add ${item.displayName}`}
                    >
                      {/* A tick once they are on the list, so a row that
                          cannot be added again says why rather than just
                          dimming its plus. */}
                      {renderActiveItem(item) ? <CheckIcon /> : <PlusIcon />}
                    </S.AddButton>
                  </S.dropDownItem>
                );
              })
            ) : (
              <S.Loader>No one matches that name</S.Loader>
            )
          ) : (
            <S.Loader>Searching…</S.Loader>
          )}
        </S.dropDownItems>
      </S.InputBox>

      {message ? (
        <S.message className={error ? 'error-message' : success ? 'success-message' : ''}>{message}</S.message>
      ) : (
        <></>
      )}
    </S.inputContainer>
  );
};

export default NotificationUserMultiDropdown;
